import {environment} from "@env";
import * as Sentry from "@sentry/angular";
import {appConfig} from "@app/app.config";
import {AppComponent} from "@app/app.component";
import {provideZoneChangeDetection} from "@angular/core";
import {bootstrapApplication} from "@angular/platform-browser";

if (environment.env === 'production') {
  Sentry.init({
    dsn: "https://915bd715b0e92d948a6e17385e92ec46@o4507443370983424.ingest.us.sentry.io/4507447541366784",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    environment: environment.env,
    /*beforeSend(event) {
      if (environment.env !== 'production') {
        return null; // drop event
      }

      return event;
    }*/
  });
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch(e => console.error(e));
